import type { BaseDocument } from '../mongo/base-document.interface';
import type { TemplateContent } from './template-content.interface';

export const TEMPLATE_TYPE = {
  CARRIER: 'carrier',
  SHIPPER: 'shipper',
} as const;

export type TemplateType = (typeof TEMPLATE_TYPE)[keyof typeof TEMPLATE_TYPE];

export interface Template extends BaseDocument {
  code: string;
  description: string;
  logo: string;
  name: string;
  templateStoragePath: string;
  type: TemplateType;
  version: number;
}

/** Minimal Template reference embedded (denormalized) into other documents. */
export type TemplateSummary = Pick<Template, 'id' | 'code' | 'name' | 'logo'>;

export type TemplateWithContent = Template & { content: TemplateContent };
